require("!!C:\\ixs\\Source\\ng_ PKUS\\node_modules\\script-loader\\addScript.js")(require("!!C:\\ixs\\Source\\ng_ PKUS\\node_modules\\raw-loader\\index.js!C:\\ixs\\Source\\ng_ PKUS\\node_modules\\moment\\moment.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/moment/moment.js
// module id = 754
// module chunks = 324